import { render, staticRenderFns } from "./PreviewJobContentRemarksForSp.vue?vue&type=template&id=3e5d2da8&scoped=true"
import script from "./PreviewJobContentRemarksForSp.vue?vue&type=script&lang=js"
export * from "./PreviewJobContentRemarksForSp.vue?vue&type=script&lang=js"
import style0 from "./PreviewJobContentRemarksForSp.vue?vue&type=style&index=0&id=3e5d2da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d2da8",
  null
  
)

export default component.exports